/**
 * `utils/debounce.js`
 *  - デバウンス
 *
 * 役割:
 *  - リサイズ連発時の負荷軽減
 *
 * 使用方法:
 *  - import {debounce} from "utils/index.js";
 *    or
 *  - import {debounce} from "utils/debounce.js";
 *
 * 関連ファイル
 *  - `utils/index.js`
 */

/**
 * デバウンス関数
 */
export const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}